import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Create, FormManager, PageTitle } from 'gossamer-front-end';
import { getListRowLink } from 'gossamer-unified';
import { OrgUnit } from 'cb-model';

export const OrgUnitCreate = (): React.JSX.Element => {
  const navigate = useNavigate();

  return (
    <>
      <PageTitle verb="Create" entity={OrgUnit} />
      <FormManager
        compoundUrl="/main/~/save"
        handleCancel={() => navigate('/admin/org-unit/search')}
        handleSuccess={({ keyOfFirstCreate }) => navigate(getListRowLink(OrgUnit.listRowLink, keyOfFirstCreate))}
        initialization={{
          main: { type: 'create-single', entity: OrgUnit },
        }}
      >
        <Create valuesKey="main" entity={OrgUnit} />
      </FormManager>
    </>
  );
};
